// @ts-nocheck

import * as Types from '../../../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type CustomObjectValuesModelFragment = {
  uid: string;
  customObjectDefinitionUid?: string | null;
  name?: string | null;
  status?: Types.StatusModel | null;
  description?: string | null;
  referenceCode?: string | null;
  referenceId?: string | null;
  customFields?: Array<{
    label?: string | null;
    value?: string | null;
    definition?: { uid: string } | null;
  } | null> | null;
};

export type GetCustomObjectsQueryVariables = Types.Exact<{
  customObjectDefinitionUid: Types.Scalars['String']['input'];
  statuses?: Types.InputMaybe<
    Array<Types.InputMaybe<Types.UpdatableStatusModel>> | Types.InputMaybe<Types.UpdatableStatusModel>
  >;
  page?: Types.InputMaybe<Types.PageModelInput>;
}>;

export type GetCustomObjectsQuery = {
  customObjects: { totalCount?: number | null; items?: Array<CustomObjectValuesModelFragment | null> | null };
};

export const CustomObjectValuesModelFragmentDoc = gql`
    fragment CustomObjectValuesModel on CustomObjectModel {
  uid
  customObjectDefinitionUid
  name
  status
  description
  referenceCode
  referenceId
  customFields {
    label
    value
    definition {
      uid
    }
  }
}
    ` as unknown as DocumentNode<CustomObjectValuesModelFragment, unknown>;
export const GetCustomObjectsDocument = gql`
    query GetCustomObjects($customObjectDefinitionUid: String!, $statuses: [UpdatableStatusModel], $page: PageModelInput) {
  customObjects(
    customObjectDefinitionUid: $customObjectDefinitionUid
    statuses: $statuses
    page: $page
  ) {
    items {
      ...CustomObjectValuesModel
    }
    totalCount
  }
}
    ${CustomObjectValuesModelFragmentDoc}` as unknown as DocumentNode<
  GetCustomObjectsQuery,
  GetCustomObjectsQueryVariables
>;
